var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCheckbox)?_c('v-simple-checkbox',{attrs:{"checked":_vm.isChecked,"value":_vm.isChecked,"disabled":""}}):_c('div',{staticClass:"templates-field-value",style:(_vm.valueStyles)},[_vm._v(_vm._s(_vm.preValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }